import { fix2digit, computeTax } from "../payment/Utilities";
import {
  getCurrentDate,
  isTimestampAfterCurrentDate,
  weekdays,
} from "../helpers/datetimeHelper";
import {
  OutcomePriceType,
  priceTriggerType,
  OutcomeType,
  RunType,
  TriggerMode,
} from "../../api/constants/priceTriggerEnums";
import store from "../../store/index";
import { DateTime } from "luxon";

export function validPriceTriggers(
  PriceTriggers,
  usedCoupons,
  cartValue,
  storeZone,
  isNewUser
) {
  let validPriceTriggers = PriceTriggers.filter((pt) => {
    const enabled = !pt.IsDisabled;
    const userValid = pt.TriggerMode != 4 || isNewUser;
    const validWithCoupon =
      !pt.NotApplicableWithCoupon || usedCoupons === false;
    const validSpend = !pt.MinimumSpend || pt.MinimumSpend <= cartValue;
    const validTime =
      (!pt.StartAt ||
        (pt.StartAt &&
          !isTimestampAfterCurrentDate(pt.StartAt.seconds, storeZone))) &&
      (!pt.EndAt ||
        (pt.EndAt && isTimestampAfterCurrentDate(pt.EndAt.seconds, storeZone)));
    const validPeriod =
      !pt.Periods ||
      pt.Periods.length == 0 ||
      validatePeriods(pt.Periods, storeZone);
    const validOrderType = pt.OrderType
      ? pt.OrderType === 4 || pt.OrderType === null
      : true;
    return (
      enabled &&
      userValid &&
      validWithCoupon &&
      validSpend &&
      validTime &&
      validPeriod &&
      validOrderType
    );
  });
  return validPriceTriggers.sort((a, b) => {
    return a.Priority - b.Priority;
  });
}
function validatePeriods(periods = [], zone) {
  let now = getCurrentDate(zone);
  let day = weekdays[now.weekday].toLowerCase();
  periods = periods || [];
  for (const period of periods) {
    let validDays = period.DaysOfWeek.map((d) => d.toLowerCase());
    let startTime = DateTime.fromFormat(period.StartTime, "HH:mm");
    let endTime = DateTime.fromFormat(period.EndTime, "HH:mm");

    if (validDays.includes(day) && now >= startTime && now <= endTime) {
      return true;
    }
  }
  return false;
}

export function calculateWholeOrderDiscount(
  priceTrigger,
  cartValue,
  soFarDiscount,
  priceTriggers
) {
  var rollExcludeSum = 0;
  var rollIntosExcludeWhole = priceTriggers.filter(
    (pt) =>
      pt.type == priceTriggerType.rollIntoMealPriceTriggers &&
      pt.selectedRollIntos &&
      pt.selectedRollIntos.length > 0 &&
      pt.Priority > priceTrigger.Priority
  );
  rollIntosExcludeWhole.forEach((rollInto) => {
    rollInto.selectedRollIntos
      .filter((p) => p.isConfirmed && p.selectedModifiers.length > 0)
      .forEach((innerRollInto) => {
        rollExcludeSum += innerRollInto.appliedDiscount;
      });
  });

  var discount;
  switch (priceTrigger.OutcomePriceType) {
    case OutcomePriceType.OutcomePriceType_PercentageDiscount:
      discount =
        (cartValue - rollExcludeSum - soFarDiscount) *
        priceTrigger.DiscountPercentageValue;
      break;
    case OutcomePriceType.DiscountFlatValue:
      discount = priceTrigger.DiscountFlatValue;
      break;
    default:
      discount = 0;
  }
  return fix2digit(discount);
}
export function calculatePerItemDiscount(priceTrigger, orderitem) {
  //TODO: perItem Discount Logic will be here
  let discount = 0;

  switch (priceTrigger.OutcomePriceType) {
    case OutcomePriceType.OutcomePriceType_PercentageDiscount:
      discount = orderitem.price * priceTrigger.DiscountPercentageValue;
      // Outcome Quantity is not applied to firebase so we set 1 for default
      var outcomeQuantity = 1;
      outcomeQuantity =
        priceTrigger.RunType == RunType.RunMultiple ? outcomeQuantity : 1;
      outcomeQuantity =
        outcomeQuantity >= orderitem.Count ? orderitem.Count : outcomeQuantity;
      discount =
        priceTrigger.RunType == RunType.RunMultiple
          ? discount * outcomeQuantity
          : discount;

      break;
    case OutcomePriceType.OutcomePriceType_FlatDiscount:
      if (priceTrigger.RunType == RunType.RunMultiple) {
        discount = priceTrigger.DiscountFlatValue * orderitem.quantity;
      } else {
        discount = priceTrigger.DiscountFlatValue;
      }
      break;
    case OutcomePriceType.OutcomePriceType_FixedPrice:
      discount = orderitem.price - priceTrigger.FixedPriceValue;
      break;
    default:
      discount = 0;
  }
  return fix2digit(discount);
}
export function priceTriggerDiscountsSum(priceTriggers) {
  var totalDiscount = 0;
  var wholeOrderDiscount = priceTriggers.find(
    (pt) => pt.type == priceTriggerType.wholeOrderDiscountPriceTriggers
  );
  if (wholeOrderDiscount) {
    totalDiscount += wholeOrderDiscount.appliedDiscount;
  }
  priceTriggers
    .filter((pt) => pt.type == priceTriggerType.perItemDiscountPriceTriggers)
    .forEach((element) => {
      totalDiscount += element.appliedDiscount;
    });
  
  priceTriggers
    .filter((pt) => pt.type == priceTriggerType.perCategoryDiscountPriceTriggers)
    .forEach((element) => {
      totalDiscount += element.appliedDiscount;
    });

  const cartItems = store.getters.cartItems.filter((p) => !p.disable);
  for (var i = 0; i < cartItems.length; i++) {
    var item = cartItems[i];

    var result = store.getters.getPriceTriggerOutcomes.find((oc) => {
      return (
        oc.order == item.uniqueId &&
        oc.type == priceTriggerType.rollIntoMealPriceTriggers
      );
    });

    if (
      result &&
      result.selectedRollIntos &&
      result.selectedRollIntos.length > 0
    ) {
      for (let j = 0; j < result.selectedRollIntos.length; j++) {
        const { ProductID } = result.rollIntoProduct;
        const categories = store.getters.getAllStoreMenus.map((menu) => {
          const cats = Array.isArray(menu.Categories) ? menu.Categories : [];
          const arrayOfMenuItems = cats.map((cat) => {
            return cat.SubMenuItems;
          });
          return [].concat(...arrayOfMenuItems);
        });
        const category = [].concat(...categories).find((item) => {
          return item.ProductID == ProductID;
        });

        if (category && category.Price) {
          totalDiscount +=
            result.AppliedQuantity * (category.Price - result.FixedPriceValue);
        }
      }
    }
  }

  //TODO: sum perItem Discount
  return totalDiscount;
}
export function rollIntoPriceSum(outcomes) {
  var rolls = outcomes.filter(
    (oc) => oc.type == priceTriggerType.rollIntoMealPriceTriggers
  );
  var sum = 0;
  rolls
    .filter((p) => p.selectedRollIntos && p.selectedRollIntos.length > 0)
    .forEach((roll) => {
      roll.selectedRollIntos
        .filter((p) => p.isConfirmed && p.selectedModifiers.length > 0)
        .forEach((innerRoll) => {
          sum += innerRoll.appliedDiscount;
        });
    });
  return sum;
}
export function incAppliedQuantity(quantityMap, id) {
  if (quantityMap[id]) {
    quantityMap[id]++;
  } else {
    quantityMap[id] = 1;
  }
}

export function createItemAppliedPriceTriggerPart(orderItem, priceTriggers) {
  var appliedPriceTriggerRecords = [];
  priceTriggers.forEach((pt) => {
    switch (pt.type) {
      case priceTriggerType.wholeOrderDiscountPriceTriggers:
        appliedPriceTriggerRecords.push({
          AffectedOrderItemQuantity: orderItem.Quantity,
          PriceTriggerID: pt.ID,
          IsResultOrderItem: false,
        });
        break;
      case priceTriggerType.rollIntoMealPriceTriggers:
        if (
          pt.order == orderItem.uniqueId &&
          pt.selectedRollIntos &&
          pt.selectedRollIntos.length > 0
        ) {
          appliedPriceTriggerRecords.push({
            AffectedOrderItemQuantity: pt.selectedRollIntos.length,
            PriceTriggerID: pt.ID,
            IsResultOrderItem: true,
          });
        }
        break;
      case priceTriggerType.perItemDiscountPriceTriggers:
        if (pt.order == orderItem.uniqueId) {
          appliedPriceTriggerRecords.push({
            AffectedOrderItemQuantity: orderItem.Quantity,
            PriceTriggerID: pt.ID,
            IsResultOrderItem: false,
          });
        }
        break;
    }
  });
  return appliedPriceTriggerRecords;
}

export function createAppliedPriceTriggerPart(orderItems, priceTriggers) {
  var appliedPriceTrigger = [];
  priceTriggers.forEach((pt) => {
    var AffectedOrderItemAndQuantity = {};
    var modifyingExcludingTax = 0;
    switch (pt.type) {
      case priceTriggerType.wholeOrderDiscountPriceTriggers:
        orderItems.forEach((orderitem) => {
          AffectedOrderItemAndQuantity[orderitem.Product_ID] =
            orderitem.Quantity;
        });
        modifyingExcludingTax = pt.appliedDiscount * -1;
        break;
      case priceTriggerType.rollIntoMealPriceTriggers:
        if (pt.selectedRollIntos && pt.selectedRollIntos.length > 0) {
          orderItems.forEach((orderitem) => {
            if (pt.order == orderitem.uniqueId) {
              AffectedOrderItemAndQuantity[orderitem.Product_ID] =
                pt.selectedRollIntos.length;
            }
          });
          modifyingExcludingTax = pt.FixedPriceValue;
          pt.selectedRollIntos.forEach((rollinto) => {
            modifyingExcludingTax += rollinto.appliedDiscount;
          });
        }
        break;
      case priceTriggerType.perItemDiscountPriceTriggers:
        orderItems
          .filter((p) => pt.order == p.uniqueId)
          .forEach((orderitem) => {
            AffectedOrderItemAndQuantity[orderitem.Product_ID] =
              pt.RunType == RunType.RunMultiple ? orderitem.Quantity : 1;
          });
        modifyingExcludingTax = pt.appliedDiscount * -1;
        break;
    }
    appliedPriceTrigger.push({
      PriceTriggerID: pt.ID,
      AffectedOrderItemAndQuantity: AffectedOrderItemAndQuantity,
      AppliedQuantity: 1,
      ModifyingTax: fix2digit(
        computeTax({
          price: modifyingExcludingTax,
          taxRate: 0.1,
        })
      ),
      ModifyingExcludingTax: modifyingExcludingTax,
    });
  });
  return appliedPriceTrigger;
}

export function calcItemAllPriceTriggerAppliedDiscount(
  orderItem,
  priceTriggers
) {
  var totalDiscount = 0;
  priceTriggers
    .filter(
      (pt) =>
        (pt.type == priceTriggerType.perItemDiscountPriceTriggers ||
          pt.type == priceTriggerType.wholeOrderDiscountPriceTriggers) &&
        pt.order == orderItem.uniqueId
    )
    .sort((a, b) => {
      return a.Priority - b.Priority;
    })
    .forEach((element) => {
      if (element.type == priceTriggerType.perItemDiscountPriceTriggers)
        totalDiscount += element.appliedDiscount;
      else if (element.type == priceTriggerType.wholeOrderDiscountPriceTriggers)
        totalDiscount +=
          element.DiscountPercentageValue * (orderItem.price - totalDiscount);
    });
  return totalDiscount;
}
export function getApplicablePriceTriggers(
  cartItems = [],
  pTriggers,
  isNewUser,
  couponApplied,
  cartValue,
  zone
) {
  let applicableTriggers = [];
  let isApplied = {};
  let priceTriggers = validPriceTriggers(
    pTriggers,
    couponApplied,
    cartValue,
    zone,
    isNewUser
  );
  let shoppingcartItems = cartItems
    .filter((p) => !p.reedemptionRule)
    .sort((a, b) => {
      return a.Price - b.Price;
    });
  for (const priceTrigger of priceTriggers) {
    if (priceTrigger.IsMostExpensiveFirst) {
      shoppingcartItems = cartItems
        .filter((p) => !p.reedemptionRule)
        .sort((a, b) => {
          return b.Price - a.Price;
        });
    }
    for (const orderItem of shoppingcartItems) {
      let outcomeType = priceTrigger.OutcomeType;
      if (
        !outcomeType ||
        outcomeType == OutcomeType.OutcomeType_FromCategories ||
        outcomeType == OutcomeType.OutcomeType_FromTags
      ) {
        outcomeType = OutcomeType.OutcomeType_Default;
      }
      if (outcomeType >= 0) {
        //meet conditions
        let match = matchConditions(
          priceTrigger,
          orderItem,
          cartItems,
          isApplied[priceTrigger.ID] || 0,
          orderItem.quantity
        );
        let allowToRun =
          (!isApplied[priceTrigger.ID] &&
            priceTrigger.RunType == RunType.RunOnce) ||
          priceTrigger.RunType == RunType.RunMultiple;
        if (match && allowToRun) {
          if (
            priceTrigger.TriggerMode == TriggerMode.TriggerWithConfirm &&
            priceTrigger.IsOutcomeLinkedToProduct == true
          ) {
            //check for roll into meal
            incAppliedQuantity(isApplied, priceTrigger.ID);
            applicableTriggers.push({
              order: orderItem.uniqueId,
              type: priceTriggerType.rollIntoMealPriceTriggers,
              ...priceTrigger,
              AppliedQuantity: isApplied[priceTrigger.ID],
            });
          }
          //check for whole order discounts
          else if (
            priceTrigger.IsOutcomeLinkedToProduct == false &&
            priceTrigger.ProductCategoryConditions.length == 0 &&
            priceTrigger.ProductTagConditions.length == 0
          ) {
            incAppliedQuantity(isApplied, priceTrigger.ID);
            applicableTriggers.push({
              order: orderItem.uniqueId,
              type: priceTriggerType.wholeOrderDiscountPriceTriggers,
              ...priceTrigger,
              AppliedQuantity: isApplied[priceTrigger.ID],
            });
          } else if (
            priceTrigger.ProductCategoryConditions.length != 0 ||
            priceTrigger.ProductTagConditions.length != 0
          ) {
            const type = checkType(priceTrigger.ProductCategoryConditions, priceTrigger.ProductTagConditions, orderItem);
            incAppliedQuantity(isApplied, priceTrigger.ID);
            applicableTriggers.push({
              order: orderItem.uniqueId,
              type,
              ...priceTrigger,
              AppliedQuantity: isApplied[priceTrigger.ID],
            });
            //TODO: per item discount
            //add order uniqueId to result object too
          }
        }
      }
    }
  }

  return applicableTriggers.sort((a, b) => {
    return a.Priority - b.Priority;
  });
}
export function checkType(productCategoryConditions, productTagConditions, orderItem) {
  let type = priceTriggerType.perItemDiscountPriceTriggers;
  if (productCategoryConditions && productCategoryConditions.length) {
    for (const condition of productCategoryConditions) {
      if (orderItem.ProductCategoryIDs.includes(condition.ProductCategoryID) && condition.Quantity > 1) {
        type = priceTriggerType.perCategoryDiscountPriceTriggers;
      }
    }
  }
  if (productTagConditions && productTagConditions.length) {
    for (const condition of productTagConditions) {
      if (orderItem.ProductTagIDs.includes(condition.ProductTagID) && condition.Quantity > 1) {
        type = priceTriggerType.perCategoryDiscountPriceTriggers;
      }
    }
  }
  return type;
}

export function matchConditions(
  priceTrigger,
  orderItem,
  cartItems = [],
  appliedQuantity,
  addQuantity = 0
) {
  //meet conditions
  let matchConditions = true;
  if (priceTrigger.OutcomeType == OutcomeType.OutcomeType_Categories) {
    const validCategory = priceTrigger.ProductOutcomesCategory.some((a) =>
      orderItem.ProductCategoryIDs.includes(a.ProductCategoryID)
    );
    if (!validCategory) {
      return false;
    }
  }

  if (
    priceTrigger.OutcomeType == OutcomeType.OutcomeType_Products &&
    orderItem.id
  ) {
    const validProduct = priceTrigger.ProductOutcomes.some(
      (a) => a.ProductID == orderItem.id.toString()
    );
    let cartQuantity = 0;
    cartItems.forEach((item) => {
      cartQuantity += item.quantity;
    });
    if (!validProduct || cartQuantity < 2) {
      return false;
    }
  }
  //ProductCategoryConditions
  if (priceTrigger.ProductCategoryConditions.length > 0) {
    for (const condition of priceTrigger.ProductCategoryConditions) {
      var totalAccur = 0;
      if (condition.ProductCategoryID && cartItems.length > 1) {
        cartItems.forEach((item) => {
          if (
            item.ProductCategoryIDs &&
            item.ProductCategoryIDs.includes(condition.ProductCategoryID)
          )
            totalAccur += item.quantity;
        });
      }

      if (
        !orderItem.ProductCategoryIDs ||
        !orderItem.ProductCategoryIDs.some((pcId) =>
          priceTrigger.ProductCategoryConditions.some(
            (ptc) => ptc.ProductCategoryID == pcId
          )
        ) ||
        totalAccur + addQuantity < condition.Quantity ||
        (appliedQuantity > 0 &&
          appliedQuantity >
            Math.floor((totalAccur + addQuantity) / condition.Quantity))
      ) {
        matchConditions = false;
      } else {
        matchConditions = true;
        break;
      }
    }
  }
  //ProductTagConditions
  if (matchConditions && priceTrigger.ProductTagConditions.length > 0) {
    for (const condition of priceTrigger.ProductTagConditions) {
      totalAccur = 0;
      if (condition.ProductTagConditions) {
        cartItems.forEach((item) => {
          if (
            item.ProductTagIDs &&
            item.ProductTagIDs.includes(condition.ProductTagConditions)
          )
            totalAccur += item.quantity;
        });
      }
      if (
        !orderItem.ProductTagIDs ||
        !orderItem.ProductTagIDs.some((ptId) =>
          priceTrigger.ProductTagConditions.some(
            (ptc) => ptc.ProductTagID == ptId
          )
        ) ||
        totalAccur + addQuantity < condition.Quantity
      ) {
        matchConditions = false;
        break;
      }
    }
  }
  return matchConditions;
}
